import React, { useState } from 'react'
import Modal from "react-bootstrap/Modal"
import { useSelector, useDispatch, } from 'react-redux'
import { Link } from 'react-router-dom'
import Card from 'react-bootstrap/Card'
import Spinner from 'react-bootstrap/Spinner'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Tooltip from "react-bootstrap/Tooltip"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import { capitalize, fullBasePath, isValidHttpUrl} from '../../../util/util'
import {
	getRelevantEvents,
	selectWorkoutIds,
	selectTaskIds,
	selectNutritionIds,
	getEventCompleteStatus,
	eventSelectedByUser
} from '../TodaysEventsSlice'
import { updateEvent } from '../TodaysEventsSlice'
import { openViewer } from '../../eventViewer/eventViewerSlice'
import classes from './EventCard.module.css'


const clipText = (s, m) => s.length > m ? `${s.substring(0, m).trim()}...` : s

const hourDiff = (dt2, dt1) => {
	const diff = ((dt2.getTime() - dt1.getTime()) / 1000) / (60 * 60);
	return diff;
}

const getTimeBadge = (timeTillNext) => {
	if (timeTillNext < -.16) return <Badge pill variant="danger">Past due</Badge>
	if (timeTillNext < 0) return <Badge pill variant="success">Now</Badge>
	if (timeTillNext < 2) return <Badge pill variant="info">Soon</Badge>
	return <Badge pill variant="primary">Later</Badge>
}

const StatusSelect = props => {
	const dispatch = useDispatch()
	const event_id = props.event.event_id
	const event_type = props.type
	const options = [
		{
			color: 'success',
			complete: 1
		}, {
			color: 'primary',
			complete: 0
		}, {
			color: 'danger',
			complete: 2
		}
	]

	function tooltipContent(color) {
		if (color === "success") {
			return "Mark Complete"
		} else if (color === "primary") {
			return "Mark Open"
		} else {
			return "Mark Not Met"
		}
	}


	return (
		<div className="d-flex align-items-center justify-content-between">
			<small className="mr-2">status</small>

			{options.map((opt, i) => (
				<OverlayTrigger
				placement="top"
				delay={{ show: 250, hide: 100 }}
				overlay={
					<Tooltip id="button-tooltip">
						{tooltipContent(opt.color)}
					</Tooltip>}
			>
				<button
					key={opt.color}
					onClick={(e) => {
						if (opt.color === "success") {
							if (props.firstGif) {
								props.setEvtSuccessModal(true);
								props.setFirstGif(false)
							}
						}
						dispatch(updateEvent({
							event_type,
							event_id,
							complete: opt.complete,
							//hold on to this for easy undo 
							//if API fails
							prevComplete: props.event.complete
						}))
						// otherwise tooltip stays visible
						e.target.blur();
					}}
					className={[
						props.complete === opt.complete ? `bg-${opt.color}` : '',
						`border border-${opt.color}`
					].join(' ')}
					style={{
						width: '16px',
						height: '16px',
						flex: '0 0 auto',
						display: 'block',
						marginRight: '4px',
						cursor: 'pointer',
						borderRadius: '100%'
					}}>
				</button>
				</OverlayTrigger>
			))}
		</div>
	)
}

const EventSnippet = props => {
	const dispatch = useDispatch()
	const { event, type } = props
	const nowDate = new Date()
	const startDate = new Date(`${event.date}T${event.start_time}`)
	const endDate = new Date(`${event.date}T${event.end_time}`)
	const timeTillNext = hourDiff(startDate, nowDate)

	const isValidURL = isValidHttpUrl(event.link)

	const startTime = startDate
		.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
	const endTime = endDate
		.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })

	const timeBadge = getTimeBadge(timeTillNext)
	const selectorParam = {
		workout: 'Workouts',
		task: 'Tasks',
		nutrition: 'Nutrition'
	}[type]
	const path = window.location.host === 'localhost:3000' ? '/icons/food/svg/' : '/assets/img/icons/food/svg/'
	return (
		<div className={classes.Snippet}>
			<div className="d-flex justify-content-between flex-wrap">
				<strong>
					{capitalize(event.title)}
				</strong>
				<div className="ml-auto" style={{flex:'0 0 auto'}}>
					<StatusSelect 
						setEvtSuccessModal={props.setEvtSuccessModal} 
						firstGif={props.firstGif} 
						setFirstGif={props.setFirstGif} 
						type={props.type} 
						event={event} 
						complete={event.complete} 
					/>
				</div>
			</div>
			<div className="d-flex justify-content-between align-items-center mb-2">
				{type === 'nutrition' && event.simplified == 1 ?
					<Link
						className="d-inline-flex align-items-center"
						style={{ background: '#00041c', padding: '2px', borderRadius: '20px' }}
						to={`/eventsView/?selector=Nutrition&display=${event.event_id}&view=list`}
					>
						<img style={{
							height: '24px',
							width: '24px',
							margin: '2px',
							background: '#00ff8c',
							borderRadius: '100%'
						}} src={`${path}/health.svg`} />
						<span style={{ color: '#fff', paddingRight: '4px' }}>View</span>
					</Link>
					:
					<Link to={ `/eventsView/?selector=${selectorParam}&display=${event.event_id}&view=list`}>
						view {type}
					</Link>
				}
			</div>
			<div>
				{Boolean(event.feature_media)&&
					<div 
						className="d-flex justify-content-center align-items-stretch" 
						style={{height:'200px'}}
					>
						<img 
							style={{display:'block',margin:'auto',maxWidth:'100%',maxHeight:'100%'}} 
							src={event.feature_media} 
							className="rounded"
						/>
					</div>
				}
				<p className="mb-2">{clipText(event.notes, 140)}</p>
				{
					event.link && isValidURL ?
					<div className="text-right">
						<a target="_blank" href={event.link} rel="noreferrer noopener"><small>link</small></a>
					</div>
					: 
					null
				}
			</div>
			<div className="d-flex justify-content-between align-items-center">
				{
					event.start_time ?
						(
							<React.Fragment>
								{event.complete == 0 ? timeBadge : <span />}
								<small className="text-muted">@ {startTime} - {endTime}</small>
							</React.Fragment>
						) : <small className="text-muted">no time set</small>
				}
			</div>
		</div>
	)
}

const EventCard = props => {

	// Event Success Modal
	const [evtSuccessModal, setEvtSuccessModal] = useState(false);

	const handleCloseEvtSuccessModal = () => setEvtSuccessModal(false);

	const type = props.type
	const events = useSelector(getRelevantEvents(type))
	const eventsStatus = useSelector(state => state.todaysEvents.status)
	const spinner = (
		<div className="d-flex justify-content-center">
			<Spinner animation="border" role="status">
				<span className="sr-only">Loading...</span>
			</Spinner>
		</div>
	)
	const bodyContent = {
		'init': spinner,
		'pending': spinner,
		'ready': (
			!events.length ? `No ${type}` :
				events?.map(event=>
					<EventSnippet 
						type={type} 
						event={event} 
						setEvtSuccessModal={setEvtSuccessModal} 
						firstGif={props.firstGif} 
						setFirstGif={props.setFirstGif} 
					/>
				)
		),
		'failed': 'Failed to load events'
	}[eventsStatus]
	const icon = {
		workout: <i className="fas fa-heartbeat text-danger"></i>,
		task: <i className="fas fa-clipboard-check text-primary"></i>,
		nutrition: <i className="fas fa-seedling text-success"></i>
	}[type]
	return (
		<>
			<Card style={{ minWidth: '300px', maxWidth: '100%' }}>
				<Card.Header style={{ background: '#000C2D' }} className="text-center">
					<span className="position-relative">
						<span style={{
							position: 'absolute',
							transform: 'translate(-100%,-50%)',
							top: '50%',
							left: '-8px'
						}}>
							{icon}
						</span>
						<span style={{ color: '#e5e7f5', fontSize: '18px' }}>{capitalize(type)}</span>
					</span>
				</Card.Header>
				<Card.Body>
					{bodyContent}
				</Card.Body>
			</Card>
			{/* Event Success Modal */}
			<Modal show={evtSuccessModal} onHide={handleCloseEvtSuccessModal}>
				<Modal.Body className="mx-auto"> <img style={{ maxWidth: "300px" }} src="https://cdn.fitsw.com/assets/img/badges/HighFive.gif" /> </Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={handleCloseEvtSuccessModal}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default EventCard